var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sub-page',{attrs:{"title":"我的地址"}},[_c('div',{staticClass:"address-page"},[_c('div',{staticClass:"empty-state"},[_c('img',{staticClass:"empty-img",attrs:{"src":_vm.emptyImg,"alt":"empty"}}),_vm._v(" "),_c('div',{staticClass:"empty-text"},[_vm._v("暂无地址")]),_vm._v(" "),_c('button',{staticClass:"add-btn",on:{"click":_vm.handleAdd}},[_vm._v("添加地址")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8e6ae17c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/MyAddress.vue
// module id = null
// module chunks = 